import { hookstate } from "@hookstate/core";
import { IAppUser } from "../models/user";

export const CURRENT_USER = hookstate<IAppUser | null>(null);

export const SIDEBAR_OPEN = hookstate<boolean>(true);
